/* Rastro de diagnóstico: los últimos acontecimientos de entrada (pulsaciones, teclas, cambios de pantalla, ventanas que se
   abren y cierran, errores) guardados en este aparato, para reconstruir un fallo que el usuario ve y el arnés de pruebas no.
   Nada sale del aparato. Se lee desde la consola: JSON.parse(localStorage.getItem('iptv:trail')). */
const KEY = 'iptv:trail';
const MAX = 120;
const ATTRS = ['data-nav', 'data-href', 'data-open', 'data-filter', 'data-settings-tab', 'data-menu', 'data-action', 'data-more', 'data-ext'];
let buf = [];
let router = null;

function describe(el) {
    if (!el || !el.tagName) return '';
    let s = el.tagName.toLowerCase();
    if (el.id) s += '#' + el.id;
    const cls = String(el.className || '').split(/\s+/).filter(Boolean).slice(0, 3);
    if (cls.length) s += '.' + cls.join('.');
    ATTRS.forEach((a) => { if (el.hasAttribute && el.hasAttribute(a)) s += '[' + a + '=' + String(el.getAttribute(a)).slice(0, 24) + ']'; });
    const text = String(el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 24);
    return text ? s + ' «' + text + '»' : s;
}

function push(k, data) {
    const e = Object.assign({ t: Date.now(), k, r: router && router.currentRoute ? router.currentRoute.url : '' }, data);
    buf.push(e);
    if (buf.length > MAX) buf.shift();
    try { localStorage.setItem(KEY, JSON.stringify(buf)); } catch (err) { /* sin almacenamiento */ }
}

/** Arranca el rastro. `app` es la instancia de Framework7. */
export function startTrail(app) {
    router = app.views.main.router;
    try { buf = JSON.parse(localStorage.getItem(KEY) || '[]').slice(-40); } catch (e) { buf = []; }
    push('start', { w: window.innerWidth, h: window.innerHeight, dpr: window.devicePixelRatio, touch: navigator.maxTouchPoints, shell: document.documentElement.getAttribute('data-shell') || 'cine', tv: document.documentElement.classList.contains('mode-tv'), ua: navigator.userAgent.slice(0, 70) });
    const ACT = '[data-nav],[data-href],[data-open],[data-filter],[data-settings-tab],[data-menu],[data-action],[data-more],a,button';
    document.addEventListener('pointerdown', (e) => push('down', { x: Math.round(e.clientX), y: Math.round(e.clientY), b: e.button, pt: e.pointerType, el: describe(e.target), act: describe(e.target.closest ? e.target.closest(ACT) : null) }), true);
    document.addEventListener('click', (e) => push('click', { x: Math.round(e.clientX), y: Math.round(e.clientY), el: describe(e.target), act: describe(e.target.closest ? e.target.closest(ACT) : null), dp: e.defaultPrevented }), true);
    document.addEventListener('click', (e) => { const last = buf[buf.length - 1]; if (last && last.k === 'click') last.end = (e.defaultPrevented ? 'prevented' : 'free') + (e.cancelBubble ? '/stopped' : ''); }, false);
    document.addEventListener('keydown', (e) => { if (String(e.key).length > 1 || e.ctrlKey || e.altKey || e.metaKey) push('key', { key: e.key, code: e.keyCode, rep: !!e.repeat }); }, true);
    document.addEventListener('visibilitychange', () => push('vis', { state: document.visibilityState }));
    router.on('routeChange', (r) => push('route', { url: r.url, hist: router.history.length }));
    app.on('modalOpen', (m) => push('open', { el: describe(m && m.el) }));
    app.on('modalClose', (m) => push('close', { el: describe(m && m.el) }));
    window.addEventListener('error', (e) => push('error', { msg: String(e.message || '').slice(0, 140), src: String(e.filename || '').slice(-40) + ':' + e.lineno }));
    window.addEventListener('unhandledrejection', (e) => push('reject', { msg: String(e.reason && e.reason.message ? e.reason.message : e.reason).slice(0, 140) }));
}

export function readTrail() { return buf.slice(); }
export function clearTrail() { buf = []; try { localStorage.removeItem(KEY); } catch (e) { /* nada */ } }
